module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-04.7aa69dd2.svg";